export const GET_COUNTRIES = 'info/GET_COUNTRIES'
export const GET_AVAILABLE_COUNTRIES = 'info/GET_AVAILABLE_COUNTRIES'
export const GET_WORLD_LANGUAGES = 'info/GET_WORLD_LANGUAGES'
export const GET_WORLD_TIMEZONES = 'info/GET_WORLD_TIMEZONES'
